import React, { Fragment, PureComponent } from "react";
import axios from "axios";
import PageLoader from "../components/PageLoader";
import { server } from "../env";
import Cookies from "js-cookie";

class DiscordCallback extends PureComponent {
  state = {};

  componentDidMount = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.referee = localStorage.getItem("ref") || "";

    axios
      .post(server + "/v1/auth/discord", params)
      .then((rsp) => {
        Cookies.set("token", rsp.data.payload.token);
        window.location.href = "/";
      })
      .catch((err) => {
        window.location.href = "/";
      });
  };
  render() {
    return (
      <Fragment>
        <PageLoader />
      </Fragment>
    );
  }
}

export default DiscordCallback;
